import React from "react";

/**
 * Logo component that renders the official logos.svg
 * @param {object} props
 * @param {string} props.className - Tailwind classes for sizing/styling
 */
export default function Logo({ className = "h-8 w-8" }) {
  return (
    <img 
      src="/assets/logos.svg" 
      alt="Logo Ditresnarkoba Polda Jateng" 
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}
